export default "__VITE_ASSET__448d40b3__";